import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonComponent} from "./button/button.component";
import {HeaderComponent} from "./header/header.component";
import {PolicyComponent} from "./policy/policy.component";

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import {PopupComponent} from "./popup/popup.component";
import {ReactiveFormsModule} from "@angular/forms";
import {NgxMaskModule} from "ngx-mask";
import {LoaderComponent} from "./loader/loader.component";
import {TransactionsPopupComponent} from "./transactions-popup/transactions-popup.component";
import {SummaryComponent} from "./summary/summary.component";
import {MoreInfoComponent} from "./moreInfo/more-info.component";
import {ConclusionComponent} from "./conclusion/conclusion.component";
import {PinPopupComponent} from "./pin-popup/pin-popup.component";
import {PaymentsInfoPopupComponent} from "./payments-info-popup/payments-info-popup.component";
import {FinancialInfoItemComponent} from "./financial-info-item/financial-info-item.component";
import {ActivityComponent} from "./activity/activity.component";
import {PopupWrapperComponent} from "./popup-wrapper/popup-wrapper.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};


@NgModule({
    declarations: [
        ButtonComponent,
        HeaderComponent,
        PolicyComponent,
        PopupComponent,
        LoaderComponent,
        TransactionsPopupComponent,
        SummaryComponent,
        MoreInfoComponent,
        ConclusionComponent,
        PinPopupComponent,
        PaymentsInfoPopupComponent,
        FinancialInfoItemComponent,
        ActivityComponent,
        PopupWrapperComponent

    ],
    imports: [
        CommonModule,
        PerfectScrollbarModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(),
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
    ],
    exports: [
        ButtonComponent,
        HeaderComponent,
        PolicyComponent,
        PopupComponent,
        LoaderComponent,
        TransactionsPopupComponent,
        SummaryComponent,
        MoreInfoComponent,
        ConclusionComponent,
        PinPopupComponent,
        PaymentsInfoPopupComponent,
        FinancialInfoItemComponent,
        ActivityComponent,
        PopupWrapperComponent
    ]
})
export class SharedModule { }
